import useFeedbackAPIClient from "../../api/feedback/hooks/useFeedbackAPIClient";

const useSubmitFeatureRequest = () => {
  const { submitFeatureRequest } = useFeedbackAPIClient();

  const submit = async (params) => {
    try {
      const response = await submitFeatureRequest({
        ...params,
      });

      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || "Failed to submit feature request",
        };
      }
    } catch (error) {
      console.error("Error submitting feature request:", error);
      return { success: false, error: error.message };
    }
  };

  return { submit };
};

export default useSubmitFeatureRequest;
